import api from '@/services/api/api'

class MaterialsService {
  getAllMaterials () {
    return api.get('material').then(result => {
      return result.data
    })
  }

  saveMaterial (material) {
    return api.post('material', material)
  }

  removeMaterial (material) {
    return api.delete('material/' + material.id)
  }
}

export default new MaterialsService()



// WEBPACK FOOTER //
// ./src/services/codebooks/MaterialsService.js